var _rect, _rect2, _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgNoDataReply(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 390,
    height: 261,
    viewBox: "0 0 390 261",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 68,
    width: 223,
    height: 12,
    rx: 2,
    fill: "#EEE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 32,
    width: 149,
    height: 24,
    rx: 2,
    fill: "#EEE"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 56,
    r: 24,
    fill: "#EEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#n57tm8fwwa)",
    d: "M0 0h390v140H0z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "n57tm8fwwa",
    x1: 195,
    y1: -49.318,
    x2: 195,
    y2: 105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgNoDataReply);
export default __webpack_public_path__ + "static/media/img_no_data_reply.10b5f03c509a6c2bacf56953233424ed.svg";
export { ForwardRef as ReactComponent };